import { Box } from "@twilio-paste/core/box";
import { css, styled } from "@twilio-paste/styling-library";

export const SeparatorContainer = styled(Box)(() =>
    css({
        gridArea: "separator",
        paddingX: ["space0", "space0", "space200"]
    })
);
